<template>
  <div id="learner-container">
    <Title title="Learners"></Title>

    <v-snackbar v-model="snackbar" bottom left :timeout="timeout">
      {{ snackbarText }}
      <JsonExcel
        v-if="showDownloadOption"
        :data="malformedDocs"
        :fields="headers"
        type="csv"
        :name="'rejected_learners.csv'"
        style="display: inline;"
      >
        <a class="ml-3 download-rejected-link">Download rejected learners</a>
      </JsonExcel>
    </v-snackbar>
    <v-container>
      <v-row>
        <v-col sm="3">
          <span style="cursor: pointer;" @click="onFilterLearners('registered')">
            <InsightCard :title="'Registered'" :count="totalRegistered" />
          </span>
        </v-col>
        <v-col sm="3">
          <span style="cursor: pointer;" @click="onFilterLearners('complete')">
            <InsightCard :title="'Completed'" :count="totalCompleted" />
          </span>
        </v-col>
        <v-col sm="3">
          <span style="cursor: pointer;" @click="onFilterLearners('in progress')">
            <InsightCard :title="'In Progress'" :count="totalInProgress" />
          </span>
        </v-col>

        <v-col sm="3">
          <span style="cursor: pointer;" @click="onFilterLearners('pending')">
            <InsightCard :title="'Pending'" :count="totalPending" />
          </span>
        </v-col>
        <v-col sm="3">
          <span style="cursor: pointer;" @click="onFilterLearners('cert. due')">
            <InsightCard :title="'Certification Due'" :count="totalCertificationDue" />
          </span>
        </v-col>
        <v-col sm="3">
          <span style="cursor: pointer;" @click="onFilterLearners('transferred')">
            <InsightCard :title="'Transferred'" :count="totaltransferred" />
          </span>
        </v-col>
        <v-col sm="3">
          <span style="cursor: pointer;" @click="onFilterLearners('withdrawn')">
            <InsightCard :title="'Withdrawn'" :count="totalWithdrawn" />
          </span>
        </v-col>
      </v-row>

      <v-row class="mt-5">
        <v-col lg="12">
          <LearnerTable
            v-if="$store.state.role != 'centre'"
            :headers="learnerHeaders"
            :items="modifiedLearners"
            :title="'learner.learner'"
            :modalText="'Learner'"
            :apiRoute="'learners'"
            :isLoading="isLearnersLoading"
            :totalCount="totalRegistered"
            :insights="learnerInsights"
            :selectedType="selectedType"
            @optionAdded="onOptionAdded"
          />
          <LearnerTable
            v-else
            :headers="centreLearnerHeaders"
            :items="modifiedLearners"
            :title="'learner.learner'"
            :modalText="'Learner'"
            :apiRoute="'learners'"
            :isLoading="isLearnersLoading"
            :totalCount="totalRegistered"
            :insights="learnerInsights"
            :selectedType="selectedType"
            @optionAdded="onOptionAdded"
          />
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import JsonExcel from "vue-json-excel";
import InsightCard from "../components/InsightCard";
import LearnerTable from "../components/LearnerTable";
import Title from "../components/Title";

export default {
  components: {
    JsonExcel,
    InsightCard,
    LearnerTable,
    Title,
  },
  mounted: function () {
    this.getLearners();
    this.getLearnerInsights();

    // display snackbar after add or edit learner
    if (this.$route.params.message) {
      this.snackbarController(this.$route.params);
    }
  },
  data() {
    return {
      snackbar: false,
      snackbarText: null,
      snackbarColor: null,
      timeout: 4000,
      showDownloadOption: false,
      learners: [],
      modifiedLearners: [],
      malformedDocs: [],
      headers: [],
      learnerInsights: null,
      isLearnersLoading: true,
      totalRegistered: 0,
      totalCompleted: 0,
      totalInProgress: 0,
      totalCertificationDue: 0,
      totaltransferred: 0,
      totalWithdrawn: 0,
      totalPending: 0,
      selectedType: "registered",
    };
  },
  computed: {
    learnerHeaders: function () {
      return [
        {
          text: this.$t("learner.code"),
          align: "start",
          value: "code",
        },
        { text: "First Name", value: "firstName" },
        { text: "Last Name", value: "lastName" },
        {
          text: "Registration Date",
          value: "firstApprovedDate",
        },
        { text: "Centre Name", value: "centre" },
        { text: this.$t("learner.status"), value: "status" },
        {
          text: this.$t("table.actions"),
          value: "actions",
          align: "end",
          sortable: false,
        },
      ];
    },
    centreLearnerHeaders: function () {
      return [
        {
          text: this.$t("learner.code"),
          align: "start",
          value: "code",
        },
        { text: "First Name", value: "firstName" },
        { text: "Last Name", value: "lastName" },
        {
          text: "Registration Date",
          value: "firstApprovedDate",
        },
        { text: this.$t("learner.status"), value: "status" },
        {
          text: this.$t("table.actions"),
          value: "actions",
          align: "end",
          sortable: false,
        },
      ];
    },
  },
  watch: {
    selectedType: function (newValue) {
      this.selectedType = newValue;
    },
    isLearnersLoading: function (newValue) {
      this.isLearnersLoading = newValue;
    },
    modifiedLearners: function (newValue) {
      this.modifiedLearners = newValue;
    },
    learnerInsights: function (newValue) {
      this.learnerInsights = newValue;
    },
  },
  methods: {
    initializeTemplateHeaders: function () {
      this.headers = {
        code: "code",
        title: "title",
        centre: "centre",
        firstApprovedDate: "firstApprovedDate",
        renewalDate: "renewalDate",
        ukprn: "ukprn",
        status: "status",
        firstName: "firstName",
        middleName: "middleName",
        lastName: "lastName",
        uln: "uln",
        dateOfBirth: "dateOfBirth",
        ethnicity: "ethnicity",
        nationality: "nationality",
        phoneNo: "phoneNo",
        mobileNo: "mobileNo",
        email: "email",
        addressLine1: "addressLine1",
        addressLine2: "addressLine2",
        addressLine3: "addressLine3",
        city: "city",
        postCode: "postCode",
        country: "country",
        qualification: "qualification",
      };
    },
    getLearners: async function () {
      try {
        const response = await fetch(
          `${
            process.env.VUE_APP_ROOT_API
          }/learners/batch?page=${1}&limit=${10}`,
          {
            headers: {
              Authorization: `Bearer ${this.$store.state.jwt}`,
            },
          }
        );

        const data = await response.json();

        this.learners.push(...data.learners);
        this.modifiedLearners.push(...data.learners);
        this.isLearnersLoading = false;
      } catch (err) {
        console.log(err);
      }
    },
    getLearnerInsights: async function () {
      try {
        const response = await fetch(
          `${process.env.VUE_APP_ROOT_API}/learners/insights`,
          {
            headers: {
              Authorization: `Bearer ${this.$store.state.jwt}`,
            },
          }
        );

        const data = await response.json();

        this.learnerInsights = data.insights;
        this.totalRegistered = data.insights.registered;
        this.totalCompleted = data.insights.completed;
        this.totalInProgress = data.insights.inProgress;
        this.totalCertificationDue = data.insights.certificationDue;
        this.totaltransferred = data.insights.transferred;
        this.totalWithdrawn = data.insights.withdrawn;
        this.totalPending = data.insights.pending;
      } catch (err) {
        console.log(err);
      }
    },
    onOptionAdded: function (data) {
      this.getLearners();
      this.snackbarController(data);
    },
    snackbarController: function (data) {
      this.snackbarText = data.message;
      this.snackbar = true;

      if (data.malformed) {
        this.timeout = 10000;
        this.showDownloadOption = true;
        this.initializeTemplateHeaders();
        this.malformedDocs = data.malformed;
      } else {
        this.timeout = 4000;
        this.showDownloadOption = false;
      }

      if (data.status == 0) {
        this.snackbarColor = "success";
      } else if (data.status == -1) {
        this.snackbarColor = "error";
      }
    },
    onFilterLearners: async function (type) {
      try {
        this.isLearnersLoading = true;

        const response = await fetch(
          `${
            process.env.VUE_APP_ROOT_API
          }/learners/batch?page=${1}&limit=${10}&type=${type}`,
          {
            headers: {
              Authorization: `Bearer ${this.$store.state.jwt}`,
            },
          }
        );

        const data = await response.json();

        this.selectedType = type;
        this.learners = data.learners;
        this.modifiedLearners = data.learners;
        this.isLearnersLoading = false;
      } catch (err) {
        console.log(err);
      }
    },
  },
};
</script>

<style scoped>
h3 {
  display: inline-block;
}

.download-rejected-link {
  color: #fff;
  text-decoration: underline;
}

#learner-container {
  min-height: 100vh;
}
</style>